import React from 'react';
import styled from 'styled-components';
import Tick_02 from '../assets/icons/Tick_02.svg';
import ModalHeader from '../components/advance/ModalHeader';

const ProfessionalEMailSentModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
  max-width: 26rem;
  height: 100%;
  border-radius: 2rem;
  .main {
    display: flex;
    flex-direction: column;
    #heading {
      text-align: left;
      font-size: 1.8rem;
      margin-top: 2.4rem;
      margin-bottom: 0.5rem;
    }
    #sub_heading {
      text-align: left;
      font-size: 1.6rem;
    }
  }
`;

const ProfessionalEMailSentModal = ({
  heading = 'Verification link sent',
  sub_heading = 'Please verify the link sent on your official email ID'
}) => {
  return (
    <ProfessionalEMailSentModalWrapper className="box">
      <ModalHeader className="main">
        <div align="center">
          <img src={Tick_02} width="96px" height="96px" alt="Tick"></img>
        </div>
        <p id="heading">
          <b>{heading} </b>
        </p>
        <p id="sub_heading">{sub_heading}</p>
      </ModalHeader>
    </ProfessionalEMailSentModalWrapper>
  );
};
export default ProfessionalEMailSentModal;
